window.$ = jQuery;

require('./modules/site-wide-header.js');
require('./modules/header-search.js');
require('./modules/animations.js');

const Alert = require('./modules/alert.js');
new Alert();
const CUCookie = require('./modules/cookie');
new CUCookie();
